import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import NewHeader from './NewHeader';
import SiteFooter from './SiteFooter';
import CartModal from '../../components/common/CartModal';
import AccountModal from '../../components/common/AccountModal';
import { useCartWishlist } from '../../context/CartWishlistContext';
import './PublicLayout.css';

const PublicLayout = () => {
  const navigate = useNavigate();
  const [cartModalOpen, setCartModalOpen] = useState(false);
  const [accountModalOpen, setAccountModalOpen] = useState(false);
  const { cartItems, cartTotal, removeFromCart, updateCartItem } = useCartWishlist();

  const handleCartCheckout = () => {
    setCartModalOpen(false);
    navigate('/user/cart');
  };

  return (
    <div className="public-layout">
      <NewHeader onCartClick={() => setCartModalOpen(true)} />
      <main className="main-content">
        <Outlet />
      </main>
      <SiteFooter />

      <CartModal
        isOpen={cartModalOpen}
        onClose={() => setCartModalOpen(false)}
        cartItems={cartItems}
        cartTotal={cartTotal}
        onRemoveItem={removeFromCart}
        onUpdateQuantity={updateCartItem}
        onCheckout={handleCartCheckout}
      />
      <AccountModal
        isOpen={accountModalOpen}
        onClose={() => setAccountModalOpen(false)}
      />
    </div>
  );
};

export default PublicLayout;
